module.exports = __webpack_public_path__ + "img/nosotros_16-9.4f28f029.webp";